import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { omit } from 'lodash'

import { users } from '../redux'

import AccountSettingsForm from '../components/AccountSettingsForm'

const AccountSettingsContainer = ({ currentUser }) => (
    <AccountSettingsForm initialValues={ omit(currentUser, 'fcm_id') } />
)

AccountSettingsContainer.propTypes = {
    currentUser: PropTypes.object
}

function mapStateToProps(state) {
    return {
        currentUser: users.getCurrent(state)
    }
}

export default connect(mapStateToProps)(AccountSettingsContainer)
